import React, { forwardRef } from "react";
import { productGroupsMappingsApi } from "@/apis/apis";
import { columns } from "./Columns";
import MappingBaseTable from "../BaseTable";
import { BASE_IMPORT_DATA } from "@/Modals/WebDataManagement/Mapping/BaseImport/baseImportData";
import { PRODUCT_GROUP_LABELS, PRODUCT_GROUPS } from "@/constant/constants";
import BaseProductProductGroupModal from "@/Modals/WebDataManagement/Mapping/BaseProductProductGroup/Modal";
import { useFilters } from "./Filters";

export default function BaseProductProductGroupPage({
  productGroup = PRODUCT_GROUPS.JERSEYS,
}) {
  const filters = useFilters(productGroup);

  const WrappedBaseProductProductGroupModal = forwardRef((_, ref) => {
    return (
      <BaseProductProductGroupModal ref={ref} productGroup={productGroup} />
    );
  });

  return (
    <MappingBaseTable
      label={`BP - PG${productGroup}`}
      apiURL={`${productGroupsMappingsApi}/${productGroup}/base-products`}
      columns={columns(productGroup)}
      filters={filters}
      ModalComponent={WrappedBaseProductProductGroupModal}
      importData={BASE_IMPORT_DATA.BASE_PRODUCT_PRODUCT_GROUP[productGroup]}
      modalDataName={""}
      enableAdd={true}
      enableEdit={true}
      enableDelete={false}
      enableSortData={false}
    />
  );
}
